import React from 'react';

import OrderNew from '@components/shared/orders/OrderNew';
import PageHeader from '@shared/PageHeader';
import { useMerchant } from '@contexts/admin/MerchantContext';
import { useMerchantData } from '@contexts/admin/MerchantDataContext';
import useOrderItemColumns from '@hooks/admin/useOrderItemColumns';

import { orderService } from '@services/admin/orderService';
import { contactAddressService } from '@services/admin/contactAddressService';
import productService from '@services/admin/productService';
import bundleService from '@services/admin/bundleService';

const AdminOrderNew = () => {
  const { currentMerchant, warehouses, defaultWarehouseId, currencies } = useMerchant();
  const { salesChannels, shippingTypes, inventoryTypes, loading: merchantDataLoading, refreshSalesChannels } = useMerchantData();
  const { enabledColumns, availableColumns, updateColumns } = useOrderItemColumns();

  return (
    <div>
      <PageHeader
        basePath="/admin"
        items={['orders', 'orders.list', 'orders.new']}
      />
      <OrderNew
      orderService={orderService}
      role="admin"
      salesChannels={salesChannels}
      onReloadSalesChannels={refreshSalesChannels}
      shippingTypes={shippingTypes}
      inventoryTypes={inventoryTypes}
      merchantDataLoading={merchantDataLoading}
      currentMerchantId={currentMerchant?.id}
      defaultCurrency={currentMerchant?.default_currency}
      currencies={currencies}
      warehouseOptions={warehouses}
      defaultWarehouseId={defaultWarehouseId}
      enabledOrderItemColumns={enabledColumns}
      availableOrderItemColumns={availableColumns}
      contactAddressService={contactAddressService}
      productService={productService}
      bundleService={bundleService}
    />
    </div>
  );
};

export default AdminOrderNew;
